"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createConfigExtendersCollection = exports.initServerApi = exports.initClientApi = exports.initApi = void 0;
// TODO: разобраться с типом any в типах, если так ОК, то удалить TODO (линтер ругался)
/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: добавить описание для всех типов, сложно разобраться в дженериках
var axios_1 = __importDefault(require("axios"));
var extensions_1 = require("./extensions");
/**
 * Создаёт api на основе декларации
 * @param apiDeclaration Декларация
 * @param config Дополнительная конфигурация api
 */
function initApi(apiDeclaration, _a) {
    var _this = this;
    var getConfigExtenders = _a.getConfigExtenders, successResultHandlers = _a.successResultHandlers;
    var api = {};
    var configExtender;
    // Wrap with axios and apply config extenders
    Object.keys(apiDeclaration).forEach(function (key) {
        api[key] = function (params, _a) {
            if (_a === void 0) { _a = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var axiosConfig, result_1, error_1;
                var logger = _a.logger, transportConfig = __rest(_a, ["logger"]);
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            axiosConfig = apiDeclaration[key](params);
                            axiosConfig = __assign(__assign({}, axiosConfig), transportConfig);
                            if (!configExtender) {
                                configExtender = getConfigExtenders(createConfigExtendersCollection());
                            }
                            axiosConfig = configExtender(axiosConfig, transportConfig);
                            if (logger) {
                                logger.apiRequest(axiosConfig);
                            }
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, axios_1.default(axiosConfig)];
                        case 2:
                            result_1 = _b.sent();
                            if (successResultHandlers) {
                                successResultHandlers.forEach(function (handler) {
                                    result_1 = handler(result_1);
                                });
                            }
                            if (logger) {
                                logger.apiResponseSuccess(axiosConfig, result_1);
                            }
                            return [2 /*return*/, result_1];
                        case 3:
                            error_1 = _b.sent();
                            if (logger) {
                                if (error_1.isAxiosError) {
                                    logger.apiResponseError(axiosConfig, error_1);
                                }
                                else {
                                    logger.apiInternalError(axiosConfig, error_1);
                                }
                            }
                            throw error_1;
                        case 4: return [2 /*return*/];
                    }
                });
            });
        };
    });
    return api;
}
exports.initApi = initApi;
/**
 * Создаёт клиентскую api на основе декларации
 * @param apiDeclaration Декларация
 * @param config Дополнительная конфигурация api
 */
function initClientApi(apiDeclaration, _a) {
    var getConfigExtenders = _a.getConfigExtenders, getApplicationId = _a.getApplicationId;
    return initApi(apiDeclaration, {
        getConfigExtenders: function (extenders) {
            return getConfigExtenders(extenders.add(extensions_1.xb3TraceId).add(extensions_1.xcsrfToken(getApplicationId())));
        },
        successResultHandlers: [
            function (result) {
                var _a, _b;
                if ((_b = (_a = result === null || result === void 0 ? void 0 : result.request) === null || _a === void 0 ? void 0 : _a.responseURL) === null || _b === void 0 ? void 0 : _b.includes('private.auth.alfabank.ru/passport/cerberus')) {
                    window.location.reload();
                }
                return result;
            },
        ],
    });
}
exports.initClientApi = initClientApi;
/**
 * Создаёт серверную api на основе декларации
 * @param apiDeclaration Декларация
 * @param config Дополнительная конфигурация api
 */
function initServerApi(apiDeclaration, _a) {
    var applicationId = _a.applicationId, getConfigExtenders = _a.getConfigExtenders;
    return initApi(apiDeclaration, {
        getConfigExtenders: function (extenders) {
            return getConfigExtenders(extenders
                .add(extensions_1.xb3TraceIdServer)
                .add(extensions_1.customerId)
                .add(extensions_1.applicationId(applicationId))
                .add(extensions_1.channelId));
        },
    });
}
exports.initServerApi = initServerApi;
/**
 * Позволяет сгруппировать несколько config extenders
 */
function createConfigExtendersCollection() {
    var configExtenders = [];
    var func = function (axiosConfig, params) {
        configExtenders.forEach(function (configExtender) {
            // eslint-disable-next-line no-param-reassign
            axiosConfig = configExtender(axiosConfig, params);
        });
        return axiosConfig;
    };
    var result = func;
    result.add = function (configExtender) {
        configExtenders.push(configExtender);
        return result;
    };
    return result;
}
exports.createConfigExtendersCollection = createConfigExtendersCollection;

//# sourceMappingURL=index.js.map
